import { visit } from 'unist-util-visit'

function processDelimiter(
  value: string,
  delimiter: string,
  nodeType: string,
  hName: string,
): { matched: boolean; children: any[] } {
  const regex = delimiter === '~' ? /(?<!\w)~([^\s~]{1,20})~(?!\w)/g : /(?<!\w)\^([^\s^]{1,20})\^(?!\w)/g

  const children: any[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  let matched = false

  while ((match = regex.exec(value)) !== null) {
    matched = true
    const content = match[1]

    if (match.index > lastIndex) {
      children.push({ type: 'text', value: value.slice(lastIndex, match.index) })
    }

    children.push({
      type: nodeType,
      data: { hName },
      children: [{ type: 'text', value: content }],
    })

    lastIndex = regex.lastIndex
  }

  if (matched && lastIndex < value.length) {
    children.push({ type: 'text', value: value.slice(lastIndex) })
  }

  return { matched, children }
}

export default function remarkSafeSuperSub() {
  return (tree: any) => {
    visit(tree, ['text'], (node: any, i: any, parent: any) => {
      if (node.type !== 'text' || !parent) return

      const { matched: supMatched, children: supChildren } = processDelimiter(node.value, '^', 'superscript', 'sup')
      if (supMatched) {
        parent.children.splice(i, 1, ...supChildren)
        return
      }

      const { matched: subMatched, children: subChildren } = processDelimiter(node.value, '~', 'subscript', 'sub')
      if (subMatched) {
        parent.children.splice(i, 1, ...subChildren)
      }
    })
  }
}
